// Phase 7 — Call Intelligence API client.
import { apiFetch } from './client';

export const callIntelligenceApi = {
  list: (params) => apiFetch('/api/call-intelligence', { params }),
  get: (id) => apiFetch(`/api/call-intelligence/${id}`),
  // Backend endpoint is on /api/calls/{callId}/analyze — NOT on the
  // /call-intelligence path — because rerun is a call action.
  rerun: (callId) =>
    apiFetch(`/api/calls/${callId}/analyze`, { method: 'POST', body: {} }),
};
